import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ error?: string | false }>`
  background-color: ${(props) => props.theme.background};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  flex-wrap: wrap;

  @media (${mobileXXLargeMax}) {
    flex-wrap: nowrap;
    overflow: auto;
    scrollbar-width: none;
  }
`;

export const Pill = styled.button<{ $active: boolean; $disabled?: boolean; $textColor?: string; $color?: string }>`
  display: flex;
  padding: 0 15px;
  border-radius: 44px;
  border: 1px solid ${({ theme }) => theme.keyline};
  align-items: center;
  justify-content: center;
  height: 44px;
  min-width: 66px;
  color: ${(props) => props.theme.textDark};

  p {
    text-align: center;
    font-size: 17px;
    flex: 1;
    white-space: nowrap;
  }

  ${({ theme, $disabled }) =>
    $disabled &&
    css`
      background-color: ${theme.backgroundLighter};

      p {
        color: ${theme.backgroundMid};
      }
    `}

  ${({ theme, $active, $color, $textColor }) =>
    $active &&
    css`
      background: ${$color || theme.primary};
      border-color: ${$color ? theme.keyline : theme.primary};
      color: ${$textColor || theme.white};

      p {
        font-weight: 600;
      }
    `}
`;
